import React from 'react';

import { ContentNotAvailable } from '../../../../../components/shared/ContentNotAvailable';
import { useNetwork } from '../../../../../hooks/useNetwork';
import { EmbeddedVideoViewer } from '../EmbeddedVideoViewer';
import { VideoLinkConverter } from '@ael/core-api';

type LinkedVideoProps = {
  url: string;
  onEnded?: () => void;
};

export const LinkedVideo: React.FC<LinkedVideoProps> = (props) => {
  const isOnline = useNetwork();
  const conversionResults = VideoLinkConverter.getEmbedCodeSrc(props.url);
  if (!conversionResults.success) {
    return null;
  }

  if (isOnline) {
    const embedCode = `<iframe width="100%" height="100%" src=${conversionResults.embedCodeSrc} frameBorder="0" allowFullScreen="true" mozallowfullscreen="true" webkitallowfullscreen="true" allowTransparency="true" ></iframe>`;
    return <EmbeddedVideoViewer embedCode={embedCode} onEnded={props.onEnded} />;
  }
  return <ContentNotAvailable />;
};
